import React from 'react'
import styles from './ItemInfo.module.css'

interface Props {
  title: string
  value: string
  classNameValue?: string
  order?: boolean
  width?: string
  height?: string
}

export const ItemInfo: React.FC<Props> = ({
  title,
  value,
  classNameValue,
  order,
  width,
  height,
}) => {
  return (
    <div className={styles.wrapper}>
      <div style={{ width: width, height: height }} className={styles.title}>
        {title}
      </div>
      <div
        style={order ? { color: 'rgba(24, 85, 153, 1)', cursor: 'pointer' } : {}}
        className={classNameValue ? classNameValue : styles.value}
      >
        {value}
      </div>
    </div>
  )
}
